import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    user: '',
    password: '',
    company: '',
    fullName : '',  
    id : '',  
    email: '',
    isLoggedIn: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {

    signIn: (state, {payload}) => {
      state.user = payload.user
      state.password = payload.password
      state.company = payload.company
      state.fullName = payload.fullName
      state.id = payload.id  
      state.email = payload.email
      state.isLoggedIn = true
    },

    signOut: (state) => {
      state.user = ''
      state.password = ''
      state.company = ''
      state.fullName = '' 
      state.id = ''
      state.email = ''
      state.isLoggedIn = false
    },
    
  },

});

export const { signIn, signOut } = authSlice.actions;

export default authSlice.reducer;